// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file consts/settlementconsts.proto (package aurora.core.consts.settlement, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file consts/settlementconsts.proto.
 */
export const file_consts_settlementconsts: GenFile = /*@__PURE__*/
  fileDesc("Ch1jb25zdHMvc2V0dGxlbWVudGNvbnN0cy5wcm90bxIdYXVyb3JhLmNvcmUuY29uc3RzLnNldHRsZW1lbnQqQwoOU2V0dGxlbWVudFR5cGUSDwoLVU5TUEVDSUZJRUQQABIICgROU0NDEAESDQoJQklMQVRFUkFMEAISBwoDT0NDEANCKVonZ2l0bGFiLnBydmJsLmNvbS9hdXJvcmEvY29yZS9zcmMvY29uc3RzYgZwcm90bzM");

/**
 * @generated from enum aurora.core.consts.settlement.SettlementType
 */
export enum SettlementType {
  /**
   * @generated from enum value: UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: NSCC = 1;
   */
  NSCC = 1,

  /**
   * @generated from enum value: BILATERAL = 2;
   */
  BILATERAL = 2,

  /**
   * @generated from enum value: OCC = 3;
   */
  OCC = 3,
}

/**
 * Describes the enum aurora.core.consts.settlement.SettlementType.
 */
export const SettlementTypeSchema: GenEnum<SettlementType> = /*@__PURE__*/
  enumDesc(file_consts_settlementconsts, 0);

